export default __webpack_public_path__ + "static/ay-glossary-knowledge-desk-sort-small-icon-d56ad15c9ad43d3a3c9352cd46f83b07.svg";